import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    bannerHeight: Number,
  };

  handleScroll(controller) {
    if (window.scrollY > controller.bannerHeightValue) {
      controller.element.classList.add("nav-add-ride-fixed");
    } else {
      controller.element.classList.remove("nav-add-ride-fixed");
    }
  }

  connect() {
    const banner = document.querySelector(".view-spy-header-container");
    if (banner) {
      this.bannerHeightValue = document.querySelector(
        ".view-spy-header-container"
      ).offsetHeight;
      window.addEventListener("scroll", () => this.handleScroll(this));
    }
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  resize() {
    const banner = document.querySelector(".view-spy-header-container");

    if (banner) {
      this.bannerHeightValue = document.querySelector(
        ".view-spy-header-container"
      ).offsetHeight;
    }
  }
}
